<template>
<div class="tel-number-form-input" :class="{ 'validation-error-group form-group--error': hasError }">
    <label v-if="label" class="tel-number-form-input__label">{{ label }}</label>

    <div :class="{ 'tel-number-form-input__field-wrap--error': hasError }" class="tel-number-form-input__field-wrap">
        <vue-tel-input
            v-model="phoneNumber"
            @input="onInput"
            @blur="onBlur"
            :preferred-countries="preferredCountries"
            mode="international"
            :input-options="{
                styleClasses: 'tel-number-form-input__input',
                name,
                required,
            }"
            :dropdown-options="{
                showDialCodeInSelection: true,
                showDialCodeInList: true,
                showFlags: true,
            }"
        >
            <template #arrow-icon="{ open }">
                <span class="vti__dropdown-arrow">{{ open ? '▲' : '▼' }}</span>
            </template>
        </vue-tel-input>
    </div>

    <small v-if="errorMessage" class="validation-error">{{ errorMessage }}</small>
</div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    components: { VueTelInput },
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: 'phone',
        },
        required: {
            type: Boolean,
            default: true,
        },
        validation: {
            type: Object,
            default: null,
        },
        backendError: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            phoneNumber: this.value,
            phoneValidationError: null,
            preferredCountries: ['RS', 'BA', 'ME', 'HR', 'CH', 'SI', 'US', 'FR', 'SE', 'IT', 'GR', 'DE'],
        };
    },
    watch: {
        value(val) {
            this.phoneNumber = val;
        },
        phoneValidationError(val) {
            this.$emit('phone-validation-error', Boolean(val));
        },
    },
    computed: {
        hasError() {
            return (
                (this.validation && this.validation.$error)
                || this.phoneValidationError
                || this.backendError
            );
        },
        errorMessage() {
            if (this.phoneValidationError) {
                return this.phoneValidationError;
            }

            if (this.backendError) {
                return this.backendError;
            }

            if (this.validation && this.validation.$error) {
                if (this.validation.$params.required && !this.validation.required) {
                    return this.$t('validation.required');
                }
                if (this.validation.$params.minLength && !this.validation.minLength) {
                    return this.$t('validation.minLength', { field: this.$t('Phone Number'), min: this.validation.$params.minLength.min });
                }
            }

            return null;
        },
    },
    methods: {
        onInput(number, telInput) {
            if (telInput.valid) {
                this.phoneValidationError = null;
                this.$emit('input', telInput.number);
            }
            else {
                this.phoneValidationError = telInput.number
                    ? this.$t('Please enter valid phone number')
                    : null;

                this.$emit('input', telInput.number || '');
            }
        },
        onBlur() {
            if (this.validation) {
                this.validation.$touch();
            }
        },
    },
};
</script>

<style>
.tel-number-form-input {
    position: relative;
}

.tel-number-form-input__label {
    display: block;
    padding-bottom: 4px;
    font-size: 14px;
    font-weight: 300;
    line-height: 20px;
}

.tel-number-form-input__field-wrap {
    border: 1px solid transparent;
    border-radius: 6px;
    overflow: visible;
}

.tel-number-form-input__field-wrap--error {
    border-color: #ef4444;
}

.tel-number-form-input .tel-number-form-input__input {
    height: 52px;
}

.tel-number-form-input .vue-tel-input,
.tel-number-form-input .vue-tel-input input,
.tel-number-form-input .vti__dropdown {
    border-radius: 6px;
}

.tel-number-form-input .vue-tel-input input {
    border: none;
}

.tel-number-form-input .vue-tel-input .vti__dropdown.open {
    position: static !important;
}

.tel-number-form-input .vue-tel-input .vti__dropdown-list {
    width: auto !important;
    top: 100% !important;
    z-index: 9999;
    text-align: left;
}

.tel-number-form-input .vue-tel-input .vti__dropdown-list li,
.tel-number-form-input .vue-tel-input .vti__dropdown-list li strong {
    color: #1f2937;
    font-weight: 400;
}

.validation-error-group .vue-tel-input {
    border: none !important;
}
.panel-register-form-wrapper .tel-number-form-input .vti__dropdown-list {
    padding-left: 0;
}
</style>
